/* What the camera looks for. */

/** The codes a warehouse prints: shipping and slot labels, retail barcodes, QR. */
export const WAREHOUSE_FORMATS = [
  'code_128',
  'ean_13',
  'ean_8',
  'upc_a',
  'upc_e',
  'itf',
  'code_39',
  'qr_code',
  'data_matrix',
];

/**
 * How often the camera looks for codes. The library's default without a
 * tracker is 500 ms; a look takes the time the phone needs to decode, and the
 * next one waits for it.
 */
export const DETECT_EVERY_MS = 200;

/**
 * How long a code has to be out of view to be read again: longer than the
 * looks the camera misses on a label held still — three in a row —, shorter
 * than reaching for the next unit of the same product.
 */
export const REREAD_GAP_MS = 800;

/** How long the guide shows a read's verdict; the camera reads the next code once it clears. */
export const READ_EFFECT_MS = 500;

/** A failed read's verdict stays longer: the operator has to see that it was read, and failed. */
export const READ_ERROR_MS = 1500;

/** How often the camera's video track is checked: the library never says it stopped. */
export const HEALTH_EVERY_MS = 1000;

/** A check this late means the page slept — the phone locked, the app in the background — and the camera with it. */
export const SLEPT_AFTER_MS = 3000;

/**
 * The back camera, at a size that reads a barcode at arm's length, focusing on
 * its own. A browser that cannot set the focus ignores it.
 */
export const CAMERA_CONSTRAINTS = {
  facingMode: { ideal: 'environment' },
  width: { ideal: 1280 },
  height: { ideal: 720 },
  advanced: [{ focusMode: 'continuous' }],
};
